<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <template>
          <div class="popup-full__content">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img src="../../assets/img/resume-popups/response.svg"
                     :alt="$tVacancy('Login as Employee for subscribe in vacancy')">
              </picture>
            </div>
            <h3 class="popup-full__title">{{ $tVacancy('Login as Employee for subscribe in vacancy') }}</h3>
            <div class="popup-full__text text">
              <p>{{ $tVacancy('Login as Employee for subscribe in vacancy description') }}</p>
            </div>
            <div class="popup-full__buttons">
              <router-link-modified :to="{name: 'auth'}"
                                    @click.native="close"
                                    class="popup-full__btn  base-btn base-btn--green">
                <span>{{ $tVacancy('Go to auth') }}</span>
              </router-link-modified>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {},
    data() {
      return {}
    },
    methods: {
      close() {
        this.$vModal.close('auth-as-employee-for-subscribe-on-vacancy')
      },
    }
  }
</script>

<style lang="less">

</style>
